// 261012 E1-P3 — thanh đầu bảng Nhân vật / Bối cảnh: đếm đủ/thiếu/sửa tay/giữ/lỗi thời + nút "Tạo đề xuất cho mục còn thiếu (N)" + tiến độ job.
// Chỉ VẼ; chữ và điều kiện bật nút ở `barView` (visualIdentityView.ts).
import React from 'react';
import { Space, Tag, Tooltip, Typography } from 'antd';
import Button from './WbButton';
import type { VisualProfileView } from '../../../types/adaptation';
import type { VisualIdentityApi } from './useVisualIdentity';
import { barView, VISUAL_JOB_RUNNING_REASON, VisualCtx, VisualTone } from './visualIdentityView';

const { Text } = Typography;
const TONE_COLOR: Record<VisualTone, string | undefined> = { ai: 'blue', user: 'green', keep: 'purple', warn: 'orange', mut: undefined };

interface Props {
  /** `profileView` của mọi thực thể trong tab (null = chưa có). */
  views: ReadonlyArray<VisualProfileView | null>;
  ctx: VisualCtx;
  api: Pick<VisualIdentityApi, 'eligible' | 'jobRunning' | 'progressText' | 'reload' | 'requestRun'>;
}

const VisualIdentityBar: React.FC<Props> = ({ views, ctx, api }) => {
  const box: React.CSSProperties = {
    display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', background: '#f0f5ff', border: '1px solid #d6e4ff', borderRadius: 6, padding: '8px 10px',
  };
  if (!ctx.loaded) {
    return (
      <div style={box}>
        <b>Nhận dạng hình ảnh:</b>
        {ctx.loadFailed
          ? <Space size={4}><Text type="secondary">Không tải được nhận dạng</Text><Button size="small" type="link" onClick={api.reload}>Thử lại</Button></Space>
          : <Text type="secondary">Đang tải…</Text>}
      </div>
    );
  }
  const bar = barView(views, ctx, api.eligible);
  return (
    <div style={box}>
      <b>Nhận dạng hình ảnh:</b>
      <span>{bar.chips.map((c) => <Tag key={c.key} color={TONE_COLOR[c.tone]} style={{ marginInlineEnd: 4 }}>{c.label}</Tag>)}</span>
      {api.jobRunning && <Tag color="blue">{`Đang đề xuất nhận dạng…${api.progressText ? ` ${api.progressText}` : ''}`}</Tag>}
      <Tooltip title={bar.runReason}>
        <span>
          <Button size="small" type="primary" disabled={!bar.canRun} onClick={() => api.requestRun('missing')}>{bar.runLabel}</Button>
        </span>
      </Tooltip>
      <Text type="secondary" style={{ fontSize: 13 }}>
        {api.jobRunning ? VISUAL_JOB_RUNNING_REASON : 'Nút chạy cho cả nhân vật và bối cảnh · chạy nền · không đụng ô đã Giữ / đã sửa tay'}
      </Text>
    </div>
  );
};

export default VisualIdentityBar;
